
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/streaming-animation.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-markdown-streaming-animation-demo-animation"],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-markdown/streaming-animation.en-US.md?type=demo')
};